import React from "react";

import ReactMarkdown, { type Options } from "react-markdown";
import RemarkGfm from "remark-gfm";
import RemarkBreaks from "remark-breaks";
import RehypeSanitize from "rehype-sanitize";
import RehypeExternalLinks from "rehype-external-links";

import "./markdown.css";
import classnames from "classnames";

const remarkPlugins: Options["remarkPlugins"] = [RemarkGfm, RemarkBreaks];
const rehypePlugins: Options["rehypePlugins"] = [RehypeSanitize, [RehypeExternalLinks, { target: "_blank" }]];

export type TMarkdownProps = Omit<Options, "unwrapDisallowed" | "skipHtml" | "remarkPlugins" | "rehypePlugins">;

export const Markdown: React.FC<TMarkdownProps> = ({ className, ...props }) => {
    if (!props.children) {
        return null;
    }

    return (
        <ReactMarkdown
            {...props}
            {...{ remarkPlugins, rehypePlugins }}
            className={classnames("react-markdown-body", className)}
            unwrapDisallowed={false}
            skipHtml
        />
    );
};
